if (!customElements.get('duft-cover-upsell')) {
  customElements.define('duft-cover-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.select = this.querySelector('[data-cover-color]');
      this.onChange = () => {
        const option = this.select.selectedOptions[0];
        this.querySelector('[data-cover-variant-id]').value = option?.value || '';
        this.querySelector('button[type="submit"]').disabled = !option?.value || option.disabled;
        if (option?.dataset.price) this.querySelector('[data-cover-price]').textContent = option.dataset.price;
        const image = this.querySelector('.duft-cover-upsell__image img');
        if (image && option?.dataset.image) {
          image.src = option.dataset.image;
          image.srcset = '';
          image.alt = option.dataset.imageAlt;
        }
      };
      this.select.addEventListener('change', this.onChange);
      this.onChange();
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.sectionId || this.dataset.fixedRefill === 'true') return;
        this.hidden = !data.variant || !/^10\s*ml$/i.test(data.variant.title.trim());
        const note = this.closest('product-info')?.querySelector('[data-cover-refill-note]');
        if (note) note.hidden = this.hidden;
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.select?.removeEventListener('change', this.onChange);
      this.initialized = false;
    }
  });
}
